import React, { useRef } from 'react'
import { useSession } from 'src/sdk/session'
import { useLocation } from '@reach/router'
import { useSelectContentEvent } from 'src/sdk/analytics/hooks/useSelectContentEvent'
import WhatsAppIcon from 'src/images/svg/WhatsAppIcon'

import { closeModal, openModal } from './whatsapp-utils'

import './WhatsApp.scss'
import { getCookie } from 'src/utils/cookie'

const WhatsApp = () => {
  const { person } = useSession()
  const { href } = useLocation()
  const { sendSelectContentEvent } = useSelectContentEvent()
  const container = useRef<HTMLDivElement>(null)
  const openContainer = useRef<HTMLDivElement>(null)
  const imageSize = 52
  const uuidToUse = getCookie('uuid')

  return (
    <>
      <div ref={container} className="chatbot-container">
        <div className="activate-chatbot">
          <button
            className="activate-chatbot__button-chatbot"
            onClick={() => openModal(openContainer)}
          >
            <WhatsAppIcon height={imageSize} width={imageSize} />
          </button>
        </div>

        <div ref={openContainer} className="open-chatbot-container">
          <p className="open-chatbot-title">PRECISA DE AJUDA?</p>
          <div className="chatbot-itens-wrapper">
            <p className="chatbot-itens-wrapper__description">
              Compre com ajuda do nosso Atendimento Inteligente
            </p>
            <a
              href="https://api.whatsapp.com/send?phone=5511987770045&text=Ol%C3%A1%2C%20gostaria%20de%20fazer%20uma%20compra%2C%20pode%20me%20ajudar%3F%20%F0%9F%99%82"
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                sendSelectContentEvent({
                  action_type: 'click_chat_wpp',
                  menu_name: 'INCIAR CHAT',
                  menu_url:
                    'https://api.whatsapp.com/send/?phone=5511987770045&text=Ol%C3%A1!%20Eu%20gostaria%20de%20realizar%20uma%20compra%20com%20%20um%20especialista!%20&app_absent=0',
                  user_id: person?.id ?? null,
                  user_logged: !!person?.id,
                  page_location: href,
                  uuid: uuidToUse
                })
              }}
            >
              <button>COMPRE</button>
            </a>
            <p>Consulte status de pedidos ou outras questões</p>
            <a
              href="https://api.whatsapp.com/send/?phone=5511987770045&text=Ol%C3%A1!%20Eu%20gostaria%20de%20iniciar%20o%20meu%20%20o%20atendimento%20&app_absent=0"
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                sendSelectContentEvent({
                  action_type: 'click_chat_wpp',
                  menu_name: 'SUPORTE VIVARA',
                  menu_url:
                    'https://api.whatsapp.com/send/?phone=5511987770045&text=Ol%C3%A1!%20Eu%20gostaria%20de%20iniciar%20o%20meu%20%20o%20atendimento%20&app_absent=0',
                  user_id: person?.id ?? null,
                  user_logged: !!person?.id,
                  page_location: href,
                  uuid: uuidToUse
                })
              }}
            >
              <button>SUPORTE VIVARA</button>
            </a>
            <div className="activate-chatbot force-position">
              <button
                className="activate-chatbot-btn-2"
                onClick={() => closeModal(openContainer)}
              >
                X
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WhatsApp
